import { useEffect, useState } from 'react';
import "./ProgrammesDynamicPage.scss";
import StaffCard from '../Our_Staff/StaffCard';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Carousel from './Carousel';
import { useParams } from 'react-router-dom';
import programmes from "../Programmes.json";
import TableComponent from "../../components/Table/TableComponent"

import baEnglish from "../../assets/Academics/UG/BA_English.jpeg";
import bscComputerScience from "../../assets/Academics/UG/BSc_Computer_Science.jpeg";
import bscInformationTechnology from "../../assets/Academics/UG/BSc_Information_Technology.jpeg";
import bscBioTechnology from "../../assets/Academics/UG/BSc_Bio_Technology.jpeg";
import bscMicroBiology from "../../assets/Academics/UG/BSc_Micro_Biology.jpeg";
import bscVisualCommunication from "../../assets/Academics/UG/BSc_Visual_Communication.jpeg";
import bscHotelManagement from "../../assets/Academics/UG/BSc_Hotel_Management.jpeg";
import bscNutrition from "../../assets/Academics/UG/BSc_Nutrition.jpeg";
import bscMaths from "../../assets/Academics/UG/BSc_Maths.jpeg";
import bscChemistry from "../../assets/Academics/UG/BSc_Chemistry.jpeg";
import bscComputerApplication from "../../assets/Academics/UG/BSc_Computer_Application.jpeg";
import bcom from "../../assets/Academics/UG/BCom.jpeg";
import bba from "../../assets/Academics/UG/BBA.jpeg";
import bscAIDS from "../../assets/Academics/UG/ai_profile_img.jpg"

import maEnglish from "../../assets/Academics/PG/MA_English.jpeg";
import mscBioTechnology from "../../assets/Academics/PG/MSc_Bio_Technology.jpeg";
import mscComputerScience from "../../assets/Academics/PG/MSc_Computer_Science.jpeg";
import mCom from "../../assets/Academics/PG/MCom.jpeg";
import mscMathematics from "../../assets/Academics/PG/MSc_Maths.jpeg";
import staff1 from "../../assets/Academics/UG/English/Janardhanan.JPG";
import staff5 from "../../assets/Academics/UG/English/AjilaJothi.JPG";
import staff3 from "../../assets/Academics/UG/English/AshlinShelina.jpeg"
import staff6 from "../../assets/Academics/UG/English/Sabitha.jpeg"
import staff2 from "../../assets/Academics/femaleavatar.jpg"
import staff4 from "../../assets/Academics/femaleavatar.jpg"
import bcastaff1 from "../../assets/Academics/UG/BCA-faculty/Mabel.JPG"
import bcastaff2 from "../../assets/Academics/UG/BCA-faculty/DrSKala.jpg"
import bcastaff3 from "../../assets/Academics/UG/BCA-faculty/MohamedKhan.JPG"
import bcastaff4 from "../../assets/Academics/UG/BCA-faculty/SophinSeeli.JPG"
import csstaff1 from "../../assets/Academics/UG/CS-faculties/JebaFreeda.JPG"
import csstaff2 from "../../assets/Academics/UG/CS-faculties/SankarGopu.JPG"
import csstaff3 from "../../assets/Academics/UG/CS-faculties/Asha.JPG"
import csstaff4 from "../../assets/Academics/UG/CS-faculties/Ramya.JPG"
import csstaff5 from "../../assets/Academics/UG/CS-faculties/Akila.jpeg"
import mathsstaff1 from "../../assets/Academics/UG/Maths/Murugesan.JPG"
import mathsstaff2 from "../../assets/Academics/femaleavatar.jpg"
import mathsstaff4 from "../../assets/Academics/femaleavatar.jpg"
import bbastaff1 from "../../assets/Academics/UG/BBA/Sugitha.JPG"
import bbastaff2 from "../../assets/Academics/UG/BBA/SheebaChristilda.JPG"
import chstaff1 from "../../assets/Academics/UG/BscChemistry/ShiningVinilPriya.jpeg"
import chstaff2 from "../../assets/Academics/UG/BscChemistry/JosephHepzin.jpeg"
import chstaff4 from "../../assets/Academics/femaleavatar.jpg"
import hmstaff1 from "../../assets/Academics/UG/HM/Mohandhas.JPG"
import itstaff1 from "../../assets/Academics/UG/IT/Deepa.JPG"
import itstaff2 from "../../assets/Academics/UG/IT/Sunitha.JPG"
import itstaff3 from "../../assets/Academics/UG/IT/Avudayappapillai.JPG"
import mbstaff1 from "../../assets/Academics/UG/MB/Dhanya.JPG"
import mbstaff2 from "../../assets/Academics/UG/MB/Sreedevi.jpeg"
import mbstaff4 from "../../assets/Academics/UG/MB/blessy.jpeg"
import mbstaff3 from "../../assets/Academics/femaleavatar.jpg"
import nutritionstaff1 from "../../assets/Academics/UG/Nutrition/JosephineBeneditBai.JPG"
import nutritionstaff2 from "../../assets/Academics/femaleavatar.jpg"
import nutritionstaff3 from "../../assets/Academics/femaleavatar.jpg"
import btstaff1 from "../../assets/Academics/UG/BT/Poornima.JPG"
import btstaff2 from "../../assets/Academics/UG/BT/Anupa.JPG"
import btstaff3 from "../../assets/Academics/UG/BT/MeeraSabari.JPG"
import bcomstaff2 from "../../assets/Academics/UG/BCOM/Babudhas.JPG"
import bcomstaff1 from "../../assets/Academics/UG/BCOM/Marimuthu.jpeg"
import bcomstaff9 from "../../assets/Academics/UG/BCOM/Sajitha.jpeg"
import bcomstaff10 from "../../assets/Academics/UG/BCOM/Remya.jpeg"
import bcomstaff7 from "../../assets/Academics/femaleavatar.jpg"
import bcomstaff11 from "../../assets/Academics/UG/BCOM/reghuKumar.jpg"
import viscomstaff1 from "../../assets/Academics/UG/Viscom/CibySKumar.JPG"
import viscomstaff2 from "../../assets/Academics/UG/Viscom/MOHAMMEDYAZEEN.jpeg"
import viscomstaff3 from "../../assets/Academics/femaleavatar.jpg"
import pgbtstaff1 from "../../assets/Academics/PG/PG-BT/Sangeetha.JPG"
import pgbtstaff2 from "../../assets/Academics/PG/PG-BT/GnanslinSheeba.JPG"
import pgbtstaff3 from "../../assets/Academics/PG/PG-BT/Sukitha.jpeg"
import pgbtstaff4 from "../../assets/Academics/femaleavatar.jpg"
import pgcsstaff1 from "../../assets/Academics/PG/PG-CS/Rajalakshmi.JPG"
import pgcsstaff2 from "../../assets/Academics/PG/PG-CS/KrishnaPrasad.jpeg"
import pgcsstaff3 from "../../assets/Academics/femaleavatar.jpg"
import maengstaff1 from "../../assets/Academics/PG/PG-Eng/MohamedMurshitha.jpeg"
import maengstaff2 from "../../assets/Academics/femaleavatar.jpg"
import bscaistaff1 from "../../assets/Academics/UG/BSCAI/StanlySherin.jpeg"
import bscaistaff2 from "../../assets/Academics/UG/BSCAI/PriyaNair.jpeg"
import mcomstaff1 from "../../assets/Academics/femaleavatar.jpg"
import mscmathsstaff2 from "../../assets/Academics/femaleavatar.jpg"

const ugAndPgCourseImages = {
    "baEnglish": baEnglish,
    "bscComputerScience": bscComputerScience,
    "bscInformationTechnology": bscInformationTechnology,
    "bscBioTechnology": bscBioTechnology,
    "bscMicroBiology": bscMicroBiology,
    "bscVisualCommunication": bscVisualCommunication,
    "bscHotelManagement": bscHotelManagement,
    "bscNutrition": bscNutrition,
    "bscMaths": bscMaths,
    "bscChemistry": bscChemistry,
    "bscComputerApplication": bscComputerApplication,
    "bscAIDS": bscAIDS,
    "bcom": bcom,
    "bba": bba,
    "maEnglish": maEnglish,
    "mscBioTechnology": mscBioTechnology,
    "mscComputerScience": mscComputerScience,
    "mCom": mCom,
    "mscMathematics": mscMathematics,
};

const facultyImages = {
    "staff1": staff1,
    "staff3": staff3,
    "staff5": staff5,
    "staff6": staff6,
    "staff2": staff2,
    "staff4": staff4,
    "bcastaff1": bcastaff1,
    "bcastaff2": bcastaff2,
    "bcastaff3": bcastaff3,
    "bcastaff4": bcastaff4,
    "csstaff1": csstaff1,
    "csstaff2": csstaff2,
    "csstaff3": csstaff3,
    "csstaff4": csstaff4,
    "csstaff5": csstaff5,
    "mathsstaff1": mathsstaff1,
    "mathsstaff2": mathsstaff2,
    "mathsstaff4": mathsstaff4,
    "bbastaff1": bbastaff1,
    "bbastaff2": bbastaff2,
    "hmstaff1": hmstaff1,
    "itstaff1": itstaff1,
    "itstaff2": itstaff2,
    "itstaff3": itstaff3,
    "mbstaff1": mbstaff1,
    "mbstaff2": mbstaff2,
    "mbstaff4": mbstaff4,
    "mbstaff3": mbstaff3,
    "nutritionstaff1": nutritionstaff1,
    "nutritionstaff2": nutritionstaff2,
    "nutritionstaff3": nutritionstaff3,
    "btstaff1": btstaff1,
    "btstaff2": btstaff2,
    "btstaff3": btstaff3,
    "bcomstaff1": bcomstaff1,
    "bcomstaff2": bcomstaff2,
    "bcomstaff9": bcomstaff9,
    "bcomstaff10": bcomstaff10,
    "bcomstaff7": bcomstaff7,
    "bcomstaff11": bcomstaff11,
    "viscomstaff1": viscomstaff1,
    "viscomstaff2": viscomstaff2,
    "viscomstaff3": viscomstaff3,
    "pgbtstaff1": pgbtstaff1,
    "pgbtstaff2": pgbtstaff2,
    "pgbtstaff3": pgbtstaff3,
    "pgbtstaff4": pgbtstaff4,
    "pgcsstaff1": pgcsstaff1,
    "pgcsstaff2": pgcsstaff2,
    "pgcsstaff3": pgcsstaff3,
    "chstaff1": chstaff1,
    "chstaff2": chstaff2,
    "chstaff4": chstaff4,
    "maengstaff1": maengstaff1,
    "maengstaff2": maengstaff2,
    "bscaistaff1": bscaistaff1,
    "bscaistaff2": bscaistaff2,
    "mcomstaff1": mcomstaff1,
    "mscmathsstaff2": mscmathsstaff2,
};

const courseImages = importAll(require.context('../../assets/Academics/', true, /\.(jpeg|png|jpg|JPG)$/));

function importAll(r) {
    let images = {};
    r.keys().forEach((file) => {
        images[file.replace('./', '').replace(/\.\w+$/, '')] = r(file);
    });
    return images;
}

const ProgrammesDynamicPage = () => {
    const { courseName } = useParams();
    const [courseData, setCourseData] = useState(null);
    const [readMore, setReadMore] = useState(false);

    useEffect(() => {
        const foundPage =
            programmes.ugProgrammes.find((item) => item.route.includes(courseName)) ||
            programmes.pgProgrammes.find((item) => item.route.includes(courseName));
        setCourseData(foundPage);
    }, [courseName, programmes]);

    if (!courseData) {
        return <h1>Page Not Found</h1>;
    }

    const renderList = (items, isOrdered = false) => {
        if (Array.isArray(items) && items.length === 1) {
            const item = items[0];
            return (
                <p>
                    {typeof item === "object" && item !== null
                        ? item.fontWeight === "bold"
                            ? <strong>{item.text}</strong>
                            : <span>{item.text}</span>
                        : <span>{item}</span>}
                </p>
            );
        }
        return isOrdered ? (
            <ol style={{ padding: "0px 0px 20px  clamp(10px, 5vw, 30px)" }}>
                {items.map((item, index) => (
                    <li key={index}>
                        {typeof item === "object" && item !== null ? (
                            <>
                                {item.text ? (
                                    item.fontWeight === "bold" ? (
                                        <strong>{item.text}</strong>
                                    ) : (
                                        <span>{item.text}</span>
                                    )
                                ) : null}
                                {Array.isArray(item.points) && renderList(item.points, item.type === "ordered")}
                            </>
                        ) : (
                            <span>{item}</span>
                        )}
                    </li>
                ))}
            </ol>
        ) : (
            <ul style={{ padding: "0px 0px 0px  clamp(10px, 5vw, 30px)" }}>
                {items.map((item, index) => (
                    <li key={index}>
                        {typeof item === "object" && item !== null ? (
                            <>
                                {item.text ? (
                                    item.fontWeight === "bold" ? (
                                        <strong>{item.text}</strong>
                                    ) : (
                                        <span>{item.text}</span>
                                    )
                                ) : null}
                                {Array.isArray(item.points) && renderList(item.points, item.type === "ordered")}
                            </>
                        ) : (
                            <span>{item}</span>
                        )}
                    </li>
                ))}
            </ul>
        );
    };

    const renderField = (key, value) => {
        if (!key.trim() && !value.trim()) return null;
        if (typeof value === "string") {
            return (
                <div className="content-parent" key={key}>
                    {key.trim() !== "" && <h3 style={{ color: "#0D553A" }}>{key}</h3>}
                    {value.trim() !== "" && <p>{value}</p>}
                </div>
            );
        }

        if (Array.isArray(value)) {
            return (
                <div className="content-parent" key={key}>
                    <h3 style={{ color: "#0D553A" }}>{key.replace(/([A-Z])/g, " $1").trim()}</h3>
                    {renderList(value, value.some(item => typeof item === "object" && item.type === "ordered"))}
                </div>
            );
        }

        if (typeof value === "object") {
            if (value.columns && value.data) {
                return (
                    <div className="content-parent" key={key} >
                        <h3>{value.title}</h3>
                        <TableComponent columns={value.columns} data={value.data} />
                    </div>
                );
            }
            return (
                <div className="content-parent" key={key}>
                    <h3 style={{ color: "#0D553A" }}>{key.replace(/([A-Z])/g, "$1").trim()}</h3>
                    {value.intro && <p>{value.intro}</p>}
                    {value.points && renderList(value.points, value.type === "ordered")}
                </div>
            );
        }
        return null;
    };

    return (
        <>
            <section className="courseContentMainContainer">
                <div className="courseContentParnet">
                    <article className="content">

                        {courseData.courseImage === "baEnglish" && (
                            <div className="initalContentParent">
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(!readMore)}
                                                className="viewMoreBtn"
                                            >
                                                {readMore ? "View Less" : "View More"}
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}

                        {courseData.courseImage === "baEnglish" && (
                            <div className="desktopView">
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}
                                {courseData["Our Motto"] && (
                                    <>
                                        <h3 style={{ color: "#0D553A" }}>Our Motto</h3>
                                        <p>
                                            {courseData["Our Motto"]}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(!readMore)}
                                                    className="viewMoreBtn"
                                                >
                                                    {readMore ? "View Less" : "View More"}
                                                </a>
                                            )}
                                        </p>
                                    </>
                                )}
                            </div>
                        )}

                        {courseData.courseImage === "bscComputerScience" && (
                            <div className="initalContentParent">
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {courseData.courseIntro && (
                                    <p>{courseData.courseIntro}</p>
                                )}

                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(!readMore)}
                                                    className="viewMoreBtn"
                                                >
                                                    {readMore ? "View Less" : "View More"}
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}

                        {courseData.courseImage === "bscComputerScience" && (
                            <div className="desktopView">
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {courseData.courseIntro && (
                                    <p>{courseData.courseIntro}</p>
                                )}

                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                        </p>
                                    </div>
                                )}

                                {courseData.Mission && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Mission</h3>
                                        <p>
                                            {courseData.Mission.substring(0, 86)}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(!readMore)}
                                                    className="viewMoreBtn"
                                                >
                                                    {readMore ? "View Less" : "View More"}
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}

                        {courseData.courseImage === "bscInformationTechnology" && (
                            <div className="initalContentParent">
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro.substring(0, 881)}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}

                        {courseData.courseImage === "bscInformationTechnology" && (
                            <div className="desktopView">
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>
                                
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro.substring(0, 1081)}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(!readMore)}
                                                className="viewMoreBtn"
                                            >
                                                {readMore ? "View Less" : "View More"}
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}

                        {/* Initial Content for B.Sc. Bio Technology */}
                        {courseData.courseImage === "bscBioTechnology" && (
                            <div className="initalContentParent">
                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>{courseData.courseIntro}</p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Desktop Initial Content for B.Sc. Bio Technology */}
                        {courseData.courseImage === "bscBioTechnology" && (
                            <div className="desktopView">
                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>{courseData.courseIntro}</p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                        </p>
                                    </div>
                                )}

                                {/* Mission */}
                                {courseData.courseImage === "bscBioTechnology" &&
                                    courseData.Mission?.points?.length > 0 && (
                                        <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <h3 style={{ color: "#0D553A" }}>Mission</h3>
                                            <ul style={{ paddingLeft: "20px" }}>
                                                {courseData.Mission.points.slice(0, 1).map((point, index) => (
                                                    <li key={index}>
                                                        {point}
                                                        {!readMore && (
                                                            <a
                                                                onClick={() => setReadMore(true)}
                                                                className="viewMoreBtn"
                                                            >
                                                                View More
                                                            </a>
                                                        )}
                                                    </li>

                                                ))}
                                            </ul>
                                        </div>
                                    )}
                            </div>
                        )}

                        {/* Initial Content for B.Sc. Micro Biology */}
                        {courseData.courseImage === "bscMicroBiology" && (
                            <div className="initalContentParent" >

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro up to 873 characters */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro.substring(0, 799)}
                                        {!readMore && courseData.courseIntro.length > 873 && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}

                        {/* Desktop Initial Content for B.Sc. Micro Biology */}
                        {courseData.courseImage === "bscMicroBiology" && (
                            <div className="desktopView" >

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro up to 979 characters */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro.substring(0, 979)}
                                        {!readMore && courseData.courseIntro.length > 979 && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}

                        {/* Initial Content for B.Sc. Visual Communication */}
                        {courseData.courseImage === "bscVisualCommunication" && (
                            <div className="initalContentParent">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro up to 799 characters */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro.substring(0, 799)}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}

                        {/* Desktop Initial Content for B.Sc. Visual Communication */}
                        {courseData.courseImage === "bscVisualCommunication" && (
                            <div className="desktopView">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}

                        {/* Initial Content for B.Sc. Hotel Management */}
                        {courseData.courseImage === "bscHotelManagement" && (
                            <div className="initalContentParent">
                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Desktop Initial Content for B.Sc. Hotel Management */}
                        {courseData.courseImage === "bscHotelManagement" && (
                            <div className="desktopView">
                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Initial Content for B.Sc. Nutrition */}
                        {courseData.courseImage === "bscNutrition" && (
                            <div className="initalContentParent">
                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision.substring(0, 74)}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Desktop Initial Content for B.Sc. Nutrition */}
                        {courseData.courseImage === "bscNutrition" && (
                            <div className="desktopView">
                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Initial Content for B.Sc. Mathematics */}
                        {courseData.courseImage === "bscMaths" && (
                            <div className="initalContentParent">
                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro.substring(0, 804)}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}

                        {/* Desktop Initial Content for B.Sc. Mathematics */}
                        {courseData.courseImage === "bscMaths" && (
                            <div className="desktopView">
                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}


                        {/* Initial Content for B.Sc. Chemistry */}
                        {courseData.courseImage === "bscChemistry" && (
                            <div className="initalContentParent">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro.substring(0, 878)}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}

                        {/* Desktop Initial Content for B.Sc. Chemistry */}
                        {courseData.courseImage === "bscChemistry" && (
                            <div className="desktopView">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}


                        {/* Initial Content for B.C.A */}
                        {courseData.courseImage === "bscComputerApplication" && (
                            <div className="initalContentParent">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro.substring(0, 882)}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}


                        {/* Desktop Initial Content for B.C.A */}
                        {courseData.courseImage === "bscComputerApplication" && (
                            <div className="desktopView">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro.substring(0, 995)}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}


                        {/* Initial Content for B.Com */}
                        {courseData.courseImage === "bcom" && (
                            <div className="initalContentParent" style={{ display: "flex", flexDirection: "column", height: "100%", gap: "15px" }}>

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Desktop Initial Content for B.Com */}
                        {courseData.courseImage === "bcom" && (
                            <div className="desktopView" style={{ display: "flex", flexDirection: "column", height: "100%", gap: "15px" }}>

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                        </p>
                                    </div>
                                )}

                                {/* Mission */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Mission</h3>
                                        <p>
                                            {courseData.Mission.substring(0, 89)}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}


                        {/* Initial Content for B.B.A */}
                        {courseData.courseImage === "bba" && (
                            <div className="initalContentParent">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}


                        {/*Desktop Initial Content for B.B.A */}
                        {courseData.courseImage === "bba" && (
                            <div className="desktopView">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision.substring(0, 85)}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}


                        {/* Initial Content for B.Sc. A.I */}
                        {courseData.courseImage === "bscAIDS" && (
                            <div className="initalContentParent">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision.substring(0, 70)}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}


                        {/*Desktop Initial Content for B.Sc. A.I */}
                        {courseData.courseImage === "bscAIDS" && (
                            <div className="desktopView">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}


                        {/* Initial Content for M.A. English */}
                        {courseData.courseImage === "maEnglish" && (
                            <div className="initalContentParent">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.courseImage === "maEnglish" &&
                                    courseData.Vision?.points?.length > 0 && (
                                        <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                            <ul style={{ paddingLeft: "20px" }}>
                                                {courseData.Vision.points.slice(0, 1).map((point, index) => (
                                                    <li key={index}>{point}</li>
                                                ))}
                                            </ul>
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </div>
                                    )}

                            </div>
                        )}

                        {/*Desktop Initial Content for M.A. English */}
                        {courseData.courseImage === "maEnglish" && (
                            <div className="desktopView">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.courseImage === "maEnglish" &&
                                    courseData.Vision?.points?.length > 0 && (
                                        <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                            <ul style={{ paddingLeft: "20px" }}>
                                                {courseData.Vision.points.slice(0, 2).map((point, index) => (
                                                    <li key={index}>{point}</li>
                                                ))}
                                            </ul>
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </div>
                                    )}

                            </div>
                        )}


                        {/* Initial Content for M.Sc. Bio Technology */}
                        {courseData.courseImage === "mscBioTechnology" && (
                            <div className="initalContentParent">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro.substring(0, 869)}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}

                        {/* Desktop Initial Content for M.Sc. Bio Technology */}
                        {courseData.courseImage === "mscBioTechnology" && (
                            <div className="desktopView">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                        {!readMore && (
                                            <a
                                                onClick={() => setReadMore(true)}
                                                className="viewMoreBtn"
                                            >
                                                View More
                                            </a>
                                        )}
                                    </p>
                                )}
                            </div>
                        )}


                        {/* Initial Content for M.Com */}
                        {courseData.courseImage === "mCom" && (
                            <div className="initalContentParent" style={{ display: "flex", flexDirection: "column", height: "100%", gap: "16px" }}>

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision.substring(0, 58)}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}


                        {/* Desktop Initial Content for M.Com */}
                        {courseData.courseImage === "mCom" && (
                            <div className="desktopView" style={{ display: "flex", flexDirection: "column", height: "100%", gap: "16px" }}>

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}


                        {/* Initial Content for M.Sc.Maths */}
                        {courseData.courseImage === "mscMathematics" && (
                            <div className="initalContentParent" style={{ display: "flex", flexDirection: "column", height: "100%", gap: "17px" }}>
                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}


                        {/* Desktop Initial Content for M.Sc.Maths */}
                        {courseData.courseImage === "mscMathematics" && (
                            <div className="desktopView" style={{ display: "flex", flexDirection: "column", height: "100%", gap: "17px" }}>
                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                            {!readMore && (
                                                <a
                                                    onClick={() => setReadMore(true)}
                                                    className="viewMoreBtn"
                                                >
                                                    View More
                                                </a>
                                            )}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}


                        {/* Initial Content for M.Sc. Computer Science */}
                        {courseData.courseImage === "mscComputerScience" && (
                            <div className="initalContentParent">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                        </p>
                                    </div>
                                )}

                                {/* Mission */}
                                {courseData.Mission && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Mission</h3>
                                        <ul style={{ paddingLeft: "20px" }}>
                                            {/* Show first two points */}
                                            {courseData.Mission.slice(0, 1).map((point, index) => (
                                                <li key={index}>
                                                    {point}
                                                    {/* Show View More after first point */}
                                                    {index === 0 && !readMore && (
                                                        <a
                                                            onClick={() => setReadMore(true)}
                                                            className="viewMoreBtn"
                                                        >
                                                            View More
                                                        </a>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )}


                        {/* Desktop Initial Content for M.Sc. Computer Science */}
                        {courseData.courseImage === "mscComputerScience" && (
                            <div className="desktopView">

                                {/* Header */}
                                <header className="programmesHeader">
                                    {courseData.course && <h2>{courseData.course}</h2>}
                                    {courseData.courseTitle && <h3>{courseData.courseTitle}</h3>}
                                </header>

                                {/* Course Intro */}
                                {courseData.courseIntro && (
                                    <p>
                                        {courseData.courseIntro}
                                    </p>
                                )}

                                {/* Vision */}
                                {courseData.Vision && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Vision</h3>
                                        <p>
                                            {courseData.Vision}
                                        </p>
                                    </div>
                                )}

                                {/* Mission */}
                                {courseData.Mission && (
                                    <div className="content-parent" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <h3 style={{ color: "#0D553A" }}>Mission</h3>
                                        <ul style={{ paddingLeft: "20px" }}>
                                            {/* Show first two points */}
                                            {courseData.Mission.slice(0, 1).map((point, index) => (
                                                <li key={index}>
                                                    {point}
                                                    {/* Show View More after first point */}
                                                    {index === 0 && !readMore && (
                                                        <a
                                                            onClick={() => setReadMore(true)}
                                                            className="viewMoreBtn"
                                                        >
                                                            View More
                                                        </a>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )}

                    </article>
                    <article
                        className="bgImage"
                        style={{ backgroundImage: `url(${ugAndPgCourseImages[courseData.courseImage]})` }}
                    >
                    </article>
                </div>

                {/* Expand View For B.A. English */}
                {readMore && courseData.courseImage === "baEnglish" && (
                    <div className="readMoreSection">

                        {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                        {Object.entries(courseData)
                            .filter(([key]) => {
                                const excludeKeys = [
                                    "course",
                                    "courseTitle",
                                    "courseIntro",
                                    "route",
                                    "routelink",
                                    "bgImage",
                                    "courseImage",
                                    "staffDetails",
                                    "thumbNailImage",
                                    "courseName",
                                ];
                                return !excludeKeys.includes(key);
                            })
                            .map(([key, value]) => renderField(key, value))}
                    </div>
                )}


                {/* Desktop Expand View For B.A. English */}
                {readMore && courseData.courseImage === "baEnglish" && (
                    <div className="desktopViewReadMoreSection">

                        {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                        {Object.entries(courseData)
                            .filter(([key]) => {
                                const excludeKeys = [
                                    "course",
                                    "courseTitle",
                                    "courseIntro",
                                    "route",
                                    "routelink",
                                    "bgImage",
                                    "courseImage",
                                    "staffDetails",
                                    "thumbNailImage",
                                    "courseName",
                                    "Our Motto",
                                ];
                                return !excludeKeys.includes(key);
                            })
                            .map(([key, value]) => renderField(key, value))}
                    </div>
                )}


                {/* Expand View For B.Sc. Computer Science */}
                {readMore && courseData.courseImage === "bscComputerScience" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscComputerScience" && (
                            <div className="readMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/*Desktop Expand View For B.Sc. Computer Science */}
                {readMore && courseData.courseImage === "bscComputerScience" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscComputerScience" && (
                            <div className="desktopViewReadMoreSection">
                                {courseData.Mission && courseData.Mission.length > 86 && (
                                    <div className="content-parent">
                                        <p>{courseData.Mission.substring(86)}</p>
                                    </div>
                                )}
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision",
                                            "Mission"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Expand View For B.Sc. Information Technology */}
                {readMore && courseData.courseImage === "bscInformationTechnology" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscInformationTechnology" && (
                            <div className="readMoreSection">
                                {courseData.courseIntro && courseData.courseIntro.length > 881 && (
                                    <div className="content-parent">
                                        <p>{courseData.courseIntro.substring(881)}</p>
                                    </div>
                                )}
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Desktop Expand View For B.Sc. Information Technology */}
                {readMore && courseData.courseImage === "bscInformationTechnology" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscInformationTechnology" && (
                            <div className="desktopViewReadMoreSection">
                                {courseData.courseIntro && courseData.courseIntro.length > 1081 && (
                                    <div className="content-parent">
                                        <p>{courseData.courseIntro.substring(1081)}</p>
                                    </div>
                                )}
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Expand View For B.Sc. Bio Technology */}
                {readMore && courseData.courseImage === "bscBioTechnology" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscBioTechnology" && (
                            <div className="readMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Desktop Expand View For B.Sc. Bio Technology */}
                {readMore && courseData.courseImage === "bscBioTechnology" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscBioTechnology" && (
                            <div className="desktopViewReadMoreSection">
                                <ul style={{ paddingLeft: "20px" }}>
                                    {readMore &&
                                        courseData.Mission.points.slice(1).map((point, index) => (
                                            <li key={index + 1}>{point}</li>
                                        ))}
                                </ul>
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision",
                                            "Mission"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Expand View For B.Sc. Micro Biology */}
                {readMore && courseData.courseImage === "bscMicroBiology" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscMicroBiology" && (
                            <div className="readMoreSection">
                                {courseData.courseIntro && courseData.courseIntro.length > 799 && (
                                    <div className="content-parent">
                                        <p>{courseData.courseIntro.substring(799)}</p>
                                    </div>
                                )}

                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision",
                                            "Mission"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Desktop Expand View For B.Sc. Micro Biology */}
                {readMore && courseData.courseImage === "bscMicroBiology" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscMicroBiology" && (
                            <div className="desktopViewReadMoreSection">
                                {courseData.courseIntro && courseData.courseIntro.length > 979 && (
                                    <div className="content-parent">
                                        <p>{courseData.courseIntro.substring(979)}</p>
                                    </div>
                                )}

                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision",
                                            "Mission"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Expand View For B.Sc. Visual Communication */}
                {readMore && courseData.courseImage === "bscVisualCommunication" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscVisualCommunication" && (
                            <div className="readMoreSection">
                                {courseData.courseIntro && courseData.courseIntro.length > 799 && (
                                    <div className="content-parent">
                                        <p>{courseData.courseIntro.substring(799)}</p>
                                    </div>
                                )}
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Mission"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}

                {/* Desktop Expand View For B.Sc. Visual Communication */}
                {readMore && courseData.courseImage === "bscVisualCommunication" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscVisualCommunication" && (
                            <div className="desktopViewReadMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Mission"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}

                {/* Expand View For B.Sc. Hotel Management */}
                {readMore && courseData.courseImage === "bscHotelManagement" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscHotelManagement" && (
                            <div className="readMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}

                {/* Desktop Expand View For B.Sc. Hotel Management */}
                {readMore && courseData.courseImage === "bscHotelManagement" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscHotelManagement" && (
                            <div className="desktopViewReadMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}

                {/* Expand View For B.Sc. Nutrition */}
                {readMore && courseData.courseImage === "bscNutrition" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscNutrition" && (
                            <div className="readMoreSection">
                                {courseData.Vision && courseData.Vision.length > 74 && (
                                    <div className="content-parent">
                                        <p>{courseData.Vision.substring(74)}</p>
                                    </div>
                                )}
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}

                {/* Desktop Expand View For B.Sc. Nutrition */}
                {readMore && courseData.courseImage === "bscNutrition" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscNutrition" && (
                            <div className="desktopViewReadMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}

                {/* Expand View For B.Sc. Maths */}
                {readMore && courseData.courseImage === "bscMaths" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscMaths" && (
                            <div className="readMoreSection">
                                {courseData.courseIntro && courseData.courseIntro.length > 804 && (
                                    <div className="content-parent">
                                        <p>{courseData.courseIntro.substring(804)}</p>
                                    </div>
                                )}
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}

                {/* Desktop Expand View For B.Sc. Maths */}
                {readMore && courseData.courseImage === "bscMaths" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscMaths" && (
                            <div className="desktopViewReadMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}

                {/* Expand View For B.C.A */}
                {readMore && courseData.courseImage === "bscComputerApplication" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscComputerApplication" && (
                            <div className="readMoreSection">
                                {courseData.courseIntro && courseData.courseIntro.length > 882 && (
                                    <div className="content-parent">
                                        <p>{courseData.courseIntro.substring(882)}</p>
                                    </div>
                                )}

                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}

                {/* Desktop Expand View For B.C.A */}
                {readMore && courseData.courseImage === "bscComputerApplication" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscComputerApplication" && (
                            <div className="desktopViewReadMoreSection">
                                {courseData.courseIntro && courseData.courseIntro.length > 995 && (
                                    <div className="content-parent">
                                        <p>{courseData.courseIntro.substring(995)}</p>
                                    </div>
                                )}

                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Expand View For B.Sc. Chemistry */}
                {readMore && courseData.courseImage === "bscChemistry" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscChemistry" && (
                            <div className="readMoreSection">
                                {courseData.courseIntro && courseData.courseIntro.length > 878 && (
                                    <div className="content-parent">
                                        <p>{courseData.courseIntro.substring(878)}</p>
                                    </div>
                                )}
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Desktop Expand View For B.Sc. Chemistry */}
                {readMore && courseData.courseImage === "bscChemistry" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscChemistry" && (
                            <div className="desktopViewReadMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Expand View For B.Com */}
                {readMore && courseData.courseImage === "bcom" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bcom" && (
                            <div className="readMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/*Desktop Expand View For B.Com */}
                {readMore && courseData.courseImage === "bcom" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bcom" && (
                            <div className="desktopViewReadMoreSection">
                                {courseData.Mission && courseData.Mission.length > 89 && (
                                    <div className="content-parent">
                                        <p>{courseData.Mission.substring(89)}</p>
                                    </div>
                                )}
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision",
                                            "Mission"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Expand View For B.B.A */}
                {readMore && courseData.courseImage === "bba" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bba" && (
                            <div className="readMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/*Desktop View Expand View For B.B.A */}
                {readMore && courseData.courseImage === "bba" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bba" && (
                            <div className="desktopViewReadMoreSection">
                                {courseData.Vision && courseData.Vision.length > 94 && (
                                    <div className="content-parent">
                                        <p>{courseData.Vision.substring(94)}</p>
                                    </div>
                                )}
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Expand View For B.Sc. A.I */}
                {readMore && courseData.courseImage === "bscAIDS" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscAIDS" && (
                            <div className="readMoreSection">
                                {courseData.Vision && courseData.Vision.length > 70 && (
                                    <div className="content-parent">
                                        <p>{courseData.Vision.substring(70)}</p>
                                    </div>
                                )}
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Desktop Expand View For B.Sc. A.I */}
                {readMore && courseData.courseImage === "bscAIDS" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "bscAIDS" && (
                            <div className="desktopViewReadMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Expand View For M.A. English */}
                {readMore && courseData.courseImage === "maEnglish" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "maEnglish" && (
                            <div className="readMoreSection">
                                {readMore &&
                                    courseData.Vision.points.slice(1).map((point, index) => (
                                        <ul style={{ paddingLeft: "20px" }}>
                                            <li key={index + 1}>{point}</li>
                                        </ul>
                                    ))}
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Desktop Expand View For M.A. English */}
                {readMore && courseData.courseImage === "maEnglish" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "maEnglish" && (
                            <div className="desktopViewReadMoreSection">

                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision"
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Expand View For M.Sc. Bio Technology */}
                {readMore && courseData.courseImage === "mscBioTechnology" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "mscBioTechnology" && (
                            <div className="readMoreSection">
                                {courseData.courseIntro && courseData.courseIntro.length > 869 && (
                                    <div className="content-parent">
                                        <p>{courseData.courseIntro.substring(869)}</p>
                                    </div>
                                )}
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}

                {/* Desktop Expand View For M.Sc. Bio Technology */}
                {readMore && courseData.courseImage === "mscBioTechnology" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "mscBioTechnology" && (
                            <div className="desktopViewReadMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Expand View For M.Com */}
                {readMore && courseData.courseImage === "mCom" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "mCom" && (
                            <div className="readMoreSection">
                                {courseData.Vision && courseData.Vision.length > 58 && (
                                    <div className="content-parent">
                                        <p>{courseData.Vision.substring(58)}</p>
                                    </div>
                                )}
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision",
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Desktop Expand View For M.Com */}
                {readMore && courseData.courseImage === "mCom" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "mCom" && (
                            <div className="desktopViewReadMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision",
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Expand View For M.Sc. Maths */}
                {readMore && courseData.courseImage === "mscMathematics" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "mscMathematics" && (
                            <div className="readMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision",
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}

                {/* Desktop Expand View For M.Sc. Maths */}
                {readMore && courseData.courseImage === "mscMathematics" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {readMore && courseData.courseImage === "mscMathematics" && (
                            <div className="desktopViewReadMoreSection">
                                {/* Render all other fields except the excluded ones and Vision (we already handled Vision above) */}
                                {Object.entries(courseData)
                                    .filter(([key]) => {
                                        const excludeKeys = [
                                            "course",
                                            "courseTitle",
                                            "courseIntro",
                                            "route",
                                            "routelink",
                                            "bgImage",
                                            "courseImage",
                                            "staffDetails",
                                            "thumbNailImage",
                                            "courseName",
                                            "Vision",
                                        ];
                                        return !excludeKeys.includes(key);
                                    })
                                    .map(([key, value]) => renderField(key, value))}
                            </div>
                        )}
                    </div>
                )}


                {/* Expand View For M.Sc. Computer Science */}
                {readMore && courseData.courseImage === "mscComputerScience" && (
                    <div className="readMoreSection" style={{ width: "100%" }}>
                        {/* Remaining Mission Points */}
                        {courseData.Mission.length > 1 && (
                            <div className="content-parent">
                                <ul style={{ paddingLeft: "20px" }}>
                                    {courseData.Mission.slice(1).map((point, index) => (
                                        <li key={index} style={{ marginBottom: "10px" }}>{point}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {/* Other Fields Except Excluded Ones */}
                        <div className="readMoreSection">
                            {Object.entries(courseData)
                                .filter(([key]) => {
                                    const excludeKeys = [
                                        "course",
                                        "courseTitle",
                                        "courseIntro",
                                        "route",
                                        "routelink",
                                        "bgImage",
                                        "courseImage",
                                        "staffDetails",
                                        "thumbNailImage",
                                        "courseName",
                                        "Vision",
                                        "Mission"
                                    ];
                                    return !excludeKeys.includes(key);
                                })
                                .map(([key, value]) => renderField(key, value))}
                        </div>
                    </div>
                )}


                {/* Desktop Expand View For M.Sc. Computer Science */}
                {readMore && courseData.courseImage === "mscComputerScience" && (
                    <div className="desktopViewReadMoreSection" style={{ width: "100%" }}>
                        {/* Remaining Mission Points */}
                        {courseData.Mission.length > 1 && (
                            <div className="content-parent">
                                <ul style={{ paddingLeft: "20px" }}>
                                    {courseData.Mission.slice(1).map((point, index) => (
                                        <li key={index} style={{ marginBottom: "10px" }}>{point}</li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {/* Other Fields Except Excluded Ones */}
                        <div className="desktopViewReadMoreSection">
                            {Object.entries(courseData)
                                .filter(([key]) => {
                                    const excludeKeys = [
                                        "course",
                                        "courseTitle",
                                        "courseIntro",
                                        "route",
                                        "routelink",
                                        "bgImage",
                                        "courseImage",
                                        "staffDetails",
                                        "thumbNailImage",
                                        "courseName",
                                        "Vision",
                                        "Mission"
                                    ];
                                    return !excludeKeys.includes(key);
                                })
                                .map(([key, value]) => renderField(key, value))}
                        </div>
                    </div>
                )}


                {/* View Less Button at the END of all rendered content */}
                {readMore && (
                    <a
                        onClick={() => setReadMore(false)}
                        style={{
                            cursor: "pointer",
                            color: "#116C4A",
                            textDecorationLine: "underline",
                            alignSelf: "flex-start",
                            paddingLeft: "10px",
                            fontFamily: "Gilroy-Medium,sans-serif",
                            fontSize: "var(--paragraph-font-size)",
                        }}
                    >
                        View Less
                    </a>
                )}

                <div>
                    <h2 >Our Faculty</h2>
                </div>
            </section >

            <div style={{ height: "auto" }}>
                <Carousel
                    data={courseData.staffDetails}
                    CardComponent={StaffCard}
                    slidesToShow={4}
                    autoplay={true}
                    facultyImages={facultyImages}
                    arrows={true}
                />
            </div>
        </>
    );
};

export default ProgrammesDynamicPage;


